/**
 * Clean Layout - Modern design
 */
import { Box } from "@mui/material";
import React from "react";

const COLORS = {
  darkBg: "#1a1a1a",
};

const Layout = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: COLORS.darkBg,
      }}
    >
      {children}
    </Box>
  );
};

export default Layout;
